import {Box} from '@chakra-ui/react';
import React from 'react';
import SimpleRowGridA from '../../Common/SimpleRowGridA';
import GridB from '../../Common/GridB';
import GridD from '../../Common/GridD';
import SimpleRowGridB from '../../Common/SimpleRowGridB';
import FullCrossPlus from "../../../../components/FullCrossPlus";
import Container from "../../../../components/Container";
import {AnimatePresence} from "framer-motion";

const HomeTechnologyPage = ({data}) => {
    const technology = data
    const firstRow = technology.slice(0, 5);
    const secondRow = technology.slice(5, 8);
    const thirdRow = technology.slice(8, 12);
    const fourthRow = technology.slice(12, 17);
    const fifthRow = technology.slice(17, 21);

    return (
        <>
            {Array(8)
                .fill('')
                .map((_, key) => (
                    <FullCrossPlus index={key + 1} top={393 * (key + 1)} key={key}/>
                ))}
            <Box borderX={'1px'} borderColor={'brandAlpha.200'}>
                <Box position={'relative'}>
                    <Container>
                        <AnimatePresence>
                            <GridD data={firstRow}/>
                            <SimpleRowGridB data={secondRow}/>
                            <SimpleRowGridA data={thirdRow}/>
                            <GridB data={fourthRow}/>
                            <SimpleRowGridA data={fifthRow}/>
                        </AnimatePresence>
                    </Container>
                </Box>
            </Box>
        </>
    );
};

export default HomeTechnologyPage;
